const Button = ({ name, onClick }) => {
  const base =
    'cursor-pointer relative text-bigButtonMobile md:text-bigButtonDesktop text-khaki uppercase font-chivoMono custom-underline group transition-all duration-500'

  return (
    <button onClick={onClick} className={base}>
      {name}
    </button>
  )
}

export default Button
